import React from 'react'
import useAnalytics from '../hooks/use-analytics'

const withAnalytic = (Component, analyticData) => props => {
  const { trackClick, trackInView } = useAnalytics(analyticData)

  return (
    <Component {...props} trackClick={trackClick} trackInView={trackInView} />
  )
}

export default withAnalytic
